<app-table
  [columnDefs]="columnDefs()"
  [rowData]="rowData()"
  [isLoading]="!columnDefs().length"
  [isSearchEnabled]="false"
  [isRecordStateFilterEnabled]="false"
  [isPaginatorEnabled]="false"
  [isPrintView]="true"
></app-table>
